"use client";

import type { SearchParams } from "~www/types/search-params";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useIsElementTruncated } from "~www/hooks/use-is-element-truncated";
import { resolveTeamMemberBioHref } from "~www/lib/about-us/resolve-team-member-bio-href";

type TeamMemberShortBioProps = {
  basePath?: string;
  bio: string;
  memberId: string;
  searchParams?: SearchParams;
};

function TeamMemberShortBio({
  basePath,
  bio,
  memberId,
  searchParams,
}: TeamMemberShortBioProps) {
  const pathname = usePathname();
  const { isTruncated, ref: bioRef } =
    useIsElementTruncated<HTMLParagraphElement>(bio);
  const bioHref = resolveTeamMemberBioHref({
    basePath,
    memberId,
    pathname,
    searchParams,
  });

  return (
    <div className="space-y-0 font-medium text-base text-new-beginnings-base leading-7 lg:max-w-[75ch]">
      <p className="line-clamp-4" ref={bioRef}>
        {bio}
      </p>
      {!isTruncated ? null : (
        <p>
          <Link
            className="font-bold text-new-beginnings-base underline underline-offset-4 hover:no-underline"
            href={bioHref}
            prefetch
            scroll={false}
          >
            Read full bio
          </Link>
        </p>
      )}
    </div>
  );
}

export { TeamMemberShortBio };
